import React, { FC, memo } from 'react';

import { toOrderedEntries, ErrorDiagnostics } from './reportText';

import styles from './DiagnosticsList.module.scss';

export interface DiagnosticsListProps {
    diagnostics: ErrorDiagnostics;
}

/** Read-only, LTR key:value diagnostics list (mirrors DebugInfo's look). */
const DiagnosticsList: FC<DiagnosticsListProps> = ({ diagnostics }) => (
    <div className={styles.container}>
        <ul className={styles.list}>
            {toOrderedEntries(diagnostics).map(([key, value]) => (
                <li className={styles.item} key={key}>
                    <span className={styles.key}>{key}:</span>
                    <span className={styles.value}>{value}</span>
                </li>
            ))}
        </ul>
    </div>
);

export default memo(DiagnosticsList);
